module.exports = __webpack_public_path__ + "static/media/upArrowIcon.f55383b1.svg";